<template>
    <div class="engine ">
        <div class="label">
          {{ $t('common.modals.create_external.engines.service-now.serviceNowSettings') }}
        </div>

        <div class="engine--description">
          {{ $t('common.modals.create_external.engines.service-now.readMoreAbout') }}
          <a class="engine--info-url" :href="serviceNowUrl" target="_blank">
            {{ $t('common.modals.create_external.engines.service-now.here') }}
          </a>
        </div>

        <or-textbox
            v-model="localServiceNowModel.settings.url"
            :label="$t('common.modals.create_external.engines.service-now.url')"
            :placeholder="$t('common.modals.create_external.engines.service-now.enterUrl')"
        />
        <or-switch v-model="localServiceNowModel.settings.isPublicUrl">{{ $t('common.modals.create_external.engines.service-now.publicUrl') }}</or-switch>
        <div
            v-if="!serviceNowModel.settings.isPublicUrl"
        >
            <or-textbox
                v-model="localServiceNowModel.settings.auth.username"
                :label="$t('common.modals.create_external.engines.service-now.username')"
                :placeholder="$t('common.modals.create_external.engines.service-now.enterUsername')"
            />
            <or-textbox
                v-model="localServiceNowModel.settings.auth.password"
                :label="$t('common.modals.create_external.engines.service-now.password')"
                :placeholder="$t('common.modals.create_external.engines.service-now.enterPassword')"
                type="password"
            />
        </div>

        <or-textbox
            v-model="localServiceNowModel.settings.modelId"
            :label="$t('common.modals.create_external.engines.service-now.modelid')"
            :placeholder="$t('common.modals.create_external.engines.service-now.enterServiceNow')"
        />

        <or-select
            v-model="localServiceNowModel.settings.method"
            :label="$t('common.modals.create_external.engines.service-now.method')"
            :options="['POST', 'GET']"
        />

        <or-code
            v-model="localServiceNowModel.settings.queryParamsTemplate"
            :label="$t('common.modals.create_external.engines.service-now.queryParams')"
            mode="json"
            :full-screen="false"
        />

        <or-code
            v-model="localServiceNowModel.settings.customHeaders"
            :label="$t('common.modals.create_external.engines.service-now.customHeaders')"
            mode="json"
            :full-screen="false"
        />

        <or-code
            v-model="localServiceNowModel.settings.bodyTemplate"
            :label="$t('common.modals.create_external.engines.service-now.bodyTemplate')"
            mode="json"
            :full-screen="false"
            :invalid="!!settingsErrors.bodyTemplate"
            :error="settingsErrors.bodyTemplate"
        />
    </div>
</template>

<script>
import { SERVICE_NOW_DOCS_URL } from '@/config'

export const getServiceNowDefaultSettings = () => ({
  url: '',
  isPublicUrl: true,
  method: 'POST',
  modelId: '',
  auth: {
    type: 'base',
    username: '',
    password: ''
  },
  customHeaders: JSON.stringify({
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }),
  queryParamsTemplate: JSON.stringify({}),
  bodyTemplate: JSON.stringify({})
})

export default {
  props: {
    serviceNowModel: {
      settings: {
        url: String,
        isPublicUrl: Boolean,
        auth: {
          type: String,
          username: String,
          password: String
        },
        modelId: '',
        method: String,
        customHeaders: String,
        queryParamsTemplate: String,
        bodyTemplate: String
      }
    },
    errors: {
      settings: {
        bodyTemplate: String
      }
    }
  },

  data () {
    return {
      serviceNowUrl: SERVICE_NOW_DOCS_URL
    }
  },

  computed: {
    settingsErrors () {
      return this.$props.errors.settings || {}
    },

    localServiceNowModel: {
      get () {
        return this.$props.serviceNowModel
      },
      set (value) {
        this.$emit('update:serviceNowModel', value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
